import  React  from "react";
import Box from "@mui/material/Box";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerGroups, getProductGroups, rejectPG, setState,rejectCG } from "./cgpgSlice";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	boxShadow: 24,
	borderRadius: 1,
	p: 3,
};

export default function RejectGroupModal() {
	const dispatch = useDispatch();
	const {
        rejectSingleModalOpen,
        rejectSelectedComment,
        selectedPeriod, 
        selectedCountryID,
        selectedGroupStatus,
        selectedView,
        productGroups, 
        customerGroups,
        selectedProductGroupName,
        selectedProductGroupID,
        selectedCustomerGroupName,
        selectedCustomerGroupID,
		selectedRows,
		searchText
	} = useSelector((store) => store.cgpgApproval);


    function handleClose() {
        dispatch(setState("rejectSingleModalOpen", false));
        dispatch(setState("rejectSelectedComment",''));
     }
  
     function setComment(event) {
        const comment = event.target.value;
        dispatch(setState("rejectSelectedComment", comment));
     }

     function search() {

        //dispatch(setState("customerGroups", null));
        //dispatch(setState("productGroups", null));
        dispatch(setState("selectedProductGroupName",""));
        dispatch(setState("selectedProductGroupID",""));
        dispatch(setState("selectedCustomerGroupName",""));
        dispatch(setState("selectedCustomerGroupID",""));
		dispatch(setState("selectedRows", []));
  
        const obj = {
              logedUser: JSON.parse(localStorage.getItem("data")),
              countryId: selectedCountryID,
              groupStatus: selectedGroupStatus,
              period: selectedPeriod,
              searchText: searchText,
          };
  
          if (selectedView === "Product Group") {
              dispatch(getProductGroups(obj));
          } else {
              dispatch(getCustomerGroups(obj));
          }
      }

	function reject() {
		debugger;
        if(selectedView === "Product Group"){
            console.log("The selected product group is ",selectedProductGroupName);
            console.log("The selected product id is ",selectedProductGroupID);
            const pid=selectedProductGroupID;
            let productGroup = productGroups.find((pg) => pg.productGroupID === pid);
			productGroup = {
				...productGroup,
				//comments: rejectSelectedComment
				comments: productGroup.comments
					? `${productGroup.comments}\n${rejectSelectedComment}`
					: rejectSelectedComment 
			 };
            const obj = {
                ...productGroup,
                isApprove: 0,
            };
            dispatch(rejectPG(obj)).then(() => {
                handleClose();
                search();
            });
        }
        else{
            console.log("The selected customer group is ",selectedCustomerGroupName);
            console.log("The selected customer group id is ",selectedCustomerGroupID);
            const cid=selectedCustomerGroupID;
            let customerGroup = customerGroups.find((cg) => cg.customerGroupID === cid);
			customerGroup = {
				...customerGroup,
				comments: customerGroup.comments
					? `${customerGroup.comments}, ${rejectSelectedComment}`
					: rejectSelectedComment 
			};
            const obj = {
                ...customerGroup,
                isApprove: 0,
             };
             dispatch(rejectCG(obj)).then(() => {
                handleClose();
                search();
            });

        }       

	}


	return (
		<div>
			<Modal
				open={rejectSingleModalOpen}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<strong>Reject:</strong>&nbsp;{selectedView==="Product Group"? selectedProductGroupName :selectedCustomerGroupName}
					<br />
					<Typography variant="subtitle2">Comments</Typography>
					<TextField
						className={'fullWidth'}
						size="large"
						multiline
						rows={6}
						style={{overflowY:'auto'}}
						value={rejectSelectedComment}
						onChange={setComment}
					/>
			       <br />
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "flex-end",
						}}
					>
						<br />
						<Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								mr: 2,
								"&:hover": {
									bgcolor: "darkred.main",
								},
							}}
							onClick={handleClose}
						>
							Close
						</Button>

						<Button
							sx={{
								bgcolor: "darkred.light",
								color: "white.main",
								textTransform: "none",
								fontWeight: "bold",
								mt: 1,
								"&:hover": {
									bgcolor: "darkred.main",
								},
							}}
							onClick={reject}
						>
							Reject
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
}
